/**
 * Internal dependencies
 */
import type { WithPermissions } from './use-entity-records';

/**
 * Utility type that adds permissions to any record type.
 */
export type { WithPermissions };
export {
	default as useEntityRecord,
	__experimentalUseEntityRecord,
} from './use-entity-record';
export {
	default as useEntityRecords,
	__experimentalUseEntityRecords,
} from './use-entity-records';
export {
	default as useResourcePermissions,
	__experimentalUseResourcePermissions,
} from './use-resource-permissions';
export { default as useEntityBlockEditor } from './use-entity-block-editor';
export { default as useEntityId } from './use-entity-id';
export { default as useEntityProp } from './use-entity-prop';
